import { format, parseISO } from "date-fns"

// A day as every table of the app writes it ("15 Oct 2026"), from the API's ISO date or timestamp.
// The day is read from the ISO text itself, so a UTC timestamp keeps its UTC day.
export function displayDay(iso) {
	if (!iso) return '—'
	const day = String(iso).slice(0, 10)
	const parsed = parseISO(day)
	return isNaN(parsed) ? String(iso) : format(parsed, 'dd MMM yyyy')
}
